import { h, Fragment } from 'preact';
import ProductGallery from '../product-gallery/product-gallery';
import ProductForm from '../product/product-form';
import { withProductContext } from '../product/product-context';

const QuickViewProduct = ({ productState, productActions, handleClose }) => {
  const { currentVariant, currentProduct, products, options, relatedProducts } =
    productState;
  const { setCurrentProduct, setCurrentVariant, setOptions } = productActions;

  return (
    <>
      <div className="flex justify-between h-80 px-24 py-28 items-center border-b border-b-grey-400">
        <div className="heading-3">
          {window.TMW.Strings.product.quickView.title}
        </div>
      </div>
      <div className="flex-1 flex flex-col h-[calc(100%-5rem)] overflow-auto hide-scrollbar bg-white">
        <ProductGallery isQuickView={true} currentProduct={currentProduct} />
        <ProductForm
          isQuickView={true}
          currentProduct={currentProduct}
          currentVariant={currentVariant}
          setCurrentVariant={setCurrentVariant}
          onAddToCart={handleClose}
          products={products}
          relatedProducts={relatedProducts}
          onProductChange={(item) => setCurrentProduct({ ...item })}
          options={options}
          setOptions={setOptions}
        />
      </div>
    </>
  );
};

export default withProductContext(QuickViewProduct);
